import brasil from "../assets/images/flags/br.svg"
import spain from "../assets/images/flags/es.svg"
import usFlag from "../assets/images/flags/us.svg"

const languages = {
  sp: {
    label: "Spanish",
    flag: spain,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
  ptBr: {
    label: "Português",
    flag: brasil,
  },
}

export default languages
